module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2018/october-09f65eabae3d0c99cb3581a12baa1872.png";